<template>
  <w-icon-wrapper icon-name='work-info-icon'>
    <path
      id="_96_Info_Icon"
      data-name="96_Info_Icon"
      d="M0,12A12,12,0,1,1,12,24,12,12,0,0,1,0,12ZM4.923,4.923A10,10,0,0,0,18.27,19.78a10.886,10.886,0,0,0,1.51-1.51A10,10,0,0,0,4.923,4.923Zm5.8,13.737V9.12H13.28v9.54ZM11,7.71a1.271,1.271,0,0,1-.39-1,1.252,1.252,0,0,1,.39-1,1.451,1.451,0,0,1,1-.37,1.471,1.471,0,0,1,1.08.37,1.25,1.25,0,0,1,.391,1,1.269,1.269,0,0,1-.391,1,1.652,1.652,0,0,1-2.08,0Z"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconInfo' };
</script>
